<template>
  <transition name="crossfade">
    <vue-draggable-resizable :parent="true" v-show="$route.name == 'home'" @dragging="onDragging" @dragstop="onDragstop" class-name="ks-switchy" :resizable="false" :z="1" :w="'auto'" :h="'auto'" :x="x" :y="y">
        <div @click="showMenu">
          <a class="switch switch-on"/>
        </div>
    </vue-draggable-resizable>
  </transition>
</template>

<script>

import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

export default {
  name: 'Switchy',
  components: { VueDraggableResizable },
  data () {
    return {
      dragged: false,
      x: Math.random() * (window.innerWidth - window.innerHeight * 0.25),
      y: Math.random() * (window.innerHeight - window.innerHeight * 0.25),
      count: 0
    }
  },
  mounted () {
  },
  methods: {
    showMenu () {
      if (this.dragged === false) {
        this.$root.Menu = true
      }
    },
    onDragging (x, y) {
      this.count++
      this.dragged = this.count > 5
    },
    onDragstop () {
      this.count = 0
      setTimeout(() => {
        this.dragged = false
      }, 10)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@import '../main';

.ks-switchy {
  z-index: 1;
  position: absolute;
  cursor: pointer;
  user-select: none;
  width: 8vw !important;
  height: 8vw !important;
  @include sm() {
    width: 8vh !important;
    height: 8vh !important;
  }
  border-radius: 50%;

  * {
    user-select: none;
  }
  .switch {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    transform: rotate(45deg);
    //transition: opacity 0.25s;
    &-on {
      background-image: url('~@/assets/lifesaver.svg');
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/Switchy.vue